export const historyConstants = {
  HISTORY_LOAD_DATA_REQUEST: 'HISTORY_LOAD_DATA_REQUEST',
  HISTORY_LOAD_DATA_SUCCESS: 'HISTORY_LOAD_DATA_SUCCESS',
  HISTORY_LOAD_DATA_FAILURE: 'HISTORY_LOAD_DATA_FAILURE',
};